// document.addEventListener("DOMContentLoaded", function () {

//   function filterImagesByColor(color) {
//     if (!color) return;

//     document.querySelectorAll("li[data-mediaalt]").forEach(function (item) {
//       var mediaAlt = item.getAttribute("data-mediaalt");

//       if (mediaAlt && mediaAlt.toLowerCase() === color.toLowerCase()) {
//         item.style.display = "block";
//        } else {
//         item.style.display = "none";
//       }
//     });
//   }

//   /* 🔹 CLICK par (tumhara existing code extended) */
//    document.querySelectorAll(".ctm_swatches").forEach(function (swatch) {
//     swatch.addEventListener("click", function () {
//       var swatchValue = this.getAttribute("data-swatch");
//       filterImagesByColor(swatchValue);
//      });
//   });

//   /* 🔹 PAGE LOAD par (checked variant se) */
//   var checkedInput = document.querySelector(
//     '.ctm_swatches input[type="radio"]:checked'
//   );

//   if (checkedInput) {
//      var parentSwatch = checkedInput.closest(".ctm_swatches");
//      var defaultColor = parentSwatch.getAttribute("data-swatch");
//     filterImagesByColor(defaultColor);
//   }

//  });


// document.addEventListener("DOMContentLoaded", function () {

//   function filterImagesByColor(color) {
//     if (!color) return;

//     document.querySelectorAll("li[data-mediaalt]").forEach(function (item) {
//        var mediaAlt = item.getAttribute("data-mediaalt");

//       if (mediaAlt && mediaAlt.toLowerCase() === color.toLowerCase()) {
//         item.style.display = "block";
//      } else {
//       item.style.display = "none";
//      }
//     });
//   }

//    /* 🔹 CLICK par (tumhara existing code extended) */
//    document.querySelectorAll(".ctm_swatches").forEach(function (swatch) {
//      swatch.addEventListener("click", function () {
//      var swatchValue = this.getAttribute("data-swatch");
//       filterImagesByColor(swatchValue);
//     });
//  });

//   /* 🔹 PAGE LOAD par (checked variant se) */
//   var checkedInput = document.querySelector(
//      '.ctm_swatches input[type="radio"]:checked'
//    );

//   if (checkedInput) {
//     var parentSwatch = checkedInput.closest(".ctm_swatches");
//     var defaultColor = parentSwatch.getAttribute("data-swatch");
//      filterImagesByColor(defaultColor);
//   }

// });







// document.addEventListener("DOMContentLoaded", function () {

//   const image = document.getElementById("spin-image");
//   const wrapper = document.querySelector(".custom-360-wrapper");

//   const totalFrames = 18;
//   const dragSpeed = 0.15; // lower = slower rotation (smooth control)

//   const basePath = "https://cdn.shopify.com/s/files/1/0700/7502/3383/files/";
//   const version = "?v=1771434363";

//   let currentFrame = 0;
//   let isDragging = false;
//   let lastX = 0;
//   let velocity = 0;

//   // ✅ Preload frames
//   const frames = [];
//   for (let i = 1; i <= totalFrames; i++) {
//     let num = i.toString().padStart(2, "0");
//     let img = new Image();
//     img.src = basePath + "frame_" + num + ".jpg" + version;
//     frames.push(img);
//   }

//   function render() {
//     let frameIndex = Math.floor(currentFrame) % totalFrames;
//     if (frameIndex < 0) frameIndex += totalFrames;
//     image.src = frames[frameIndex].src;
//   }

//   function animate() {
//     if (!isDragging && Math.abs(velocity) > 0.01) {
//       currentFrame += velocity;
//       velocity *= 0.95; // friction (smooth slow down)
//       render();
//     }
//     requestAnimationFrame(animate);
//   }

//   animate();

//   function startDrag(x) {
//     isDragging = true;
//     lastX = x;
//     velocity = 0;
//     wrapper.style.cursor = "grabbing";
//   }

//   function stopDrag() {
//     isDragging = false;
//     wrapper.style.cursor = "grab";
//   }

//   function dragMove(x) {
//     if (!isDragging) return;

//     let delta = lastX - x; // correct direction
//     velocity = delta * dragSpeed;
//     currentFrame += velocity;
//     render();
//     lastX = x;
//   }

//   // Desktop
//   wrapper.addEventListener("mousedown", e => startDrag(e.pageX));
//   window.addEventListener("mouseup", stopDrag);
//   window.addEventListener("mousemove", e => dragMove(e.pageX));

//   // Mobile
//   wrapper.addEventListener("touchstart", e => startDrag(e.touches[0].pageX));
//   window.addEventListener("touchend", stopDrag);
//   window.addEventListener("touchmove", e => dragMove(e.touches[0].pageX));

// });

document.addEventListener("DOMContentLoaded", function () {

  const img = document.getElementById("variant-360-image");
  const wrapper = document.getElementById("variant360Wrap");

  if (!img || !wrapper) return;

  let currentImages = [];
  let currentFrame = 0;
  let isDragging = false;
  let startX = 0;
  let lastVariantId = null;

  function getVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  function loadImages(variantId) {

    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    const data = window.variant360Data[variantId];

    // RESET
    currentImages = [];
    currentFrame = 0;
    isDragging = false;
    img.src = "";

    if (!data) {
      wrapper.style.display = "none";
      return;
    }

    const images = data.images || [];

    // ✅ CASE 1: 360 images available
    if (images.length > 0) {
      wrapper.style.display = "block";
      currentImages = images.slice();
      img.src = currentImages[0];
      return;
    }

    // ✅ CASE 2: NO 360 → show variant image
    if (data.fallback) {
      wrapper.style.display = "block";
      img.src = data.fallback;
      currentImages = []; // no drag
      return;
    }

    // ❌ nothing
    wrapper.style.display = "none";
  }

  // Initial load
  loadImages(getVariantId());

  // FORM change
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener("change", function () {
      loadImages(getVariantId());
    });
  }

  // fallback polling
  setInterval(() => {
    loadImages(getVariantId());
  }, 300);

  // =========================
  // DRAG (only if 360 exists)
  // =========================

  wrapper.addEventListener("mousedown", e => {
    if (!currentImages.length) return;
    isDragging = true;
    startX = e.pageX;
  });

  window.addEventListener("mouseup", () => {
    isDragging = false;
  });

  wrapper.addEventListener("mousemove", e => {
    if (!isDragging || !currentImages.length) return;

    const diff = e.pageX - startX;

    if (Math.abs(diff) > 8) {
      currentFrame = diff > 0
        ? (currentFrame + 1) % currentImages.length
        : (currentFrame - 1 + currentImages.length) % currentImages.length;

      img.src = currentImages[currentFrame];
      startX = e.pageX;
    }
  });

  // Mobile
  wrapper.addEventListener("touchstart", e => {
    if (!currentImages.length) return;
    isDragging = true;
    startX = e.touches[0].pageX;
  });

  wrapper.addEventListener("touchend", () => {
    isDragging = false;
  });

  wrapper.addEventListener("touchmove", e => {
    if (!isDragging || !currentImages.length) return;

    const diff = e.touches[0].pageX - startX;

    if (Math.abs(diff) > 8) {
      currentFrame = diff > 0
        ? (currentFrame + 1) % currentImages.length
        : (currentFrame - 1 + currentImages.length) % currentImages.length;

      img.src = currentImages[currentFrame];
      startX = e.touches[0].pageX;
    }
  });

});

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".custom-360-wrapper").forEach((wrapper, index) => {

//     const img = wrapper.querySelector(".spin-image");
//     const productId = img.id.split("-")[2];

//     const images = window["product360Images_" + productId];

//     if (!images || images.length === 0) return;

//     let currentFrame = 0;
//     let isDragging = false;
//     let startX = 0;

//     img.src = images[0];

//     wrapper.addEventListener("mousedown", (e) => {
//       isDragging = true;
//       startX = e.pageX;
//     });

//     window.addEventListener("mouseup", () => {
//       isDragging = false;
//     });

//     wrapper.addEventListener("mousemove", (e) => {
//       if (!isDragging) return;

//       let diff = e.pageX - startX;

//       if (Math.abs(diff) > 5) {
//         if (diff > 0) {
//           currentFrame = (currentFrame + 1) % images.length;
//         } else {
//           currentFrame = (currentFrame - 1 + images.length) % images.length;
//         }

//         img.src = images[currentFrame];
//         startX = e.pageX;
//       }
//     });

//     // Mobile Support
//     wrapper.addEventListener("touchstart", (e) => {
//       isDragging = true;
//       startX = e.touches[0].pageX;
//     });

//     wrapper.addEventListener("touchend", () => {
//       isDragging = false;
//     });

//     wrapper.addEventListener("touchmove", (e) => {
//       if (!isDragging) return;

//       let diff = e.touches[0].pageX - startX;

//       if (Math.abs(diff) > 5) {
//         if (diff > 0) {
//           currentFrame = (currentFrame + 1) % images.length;
//         } else {
//           currentFrame = (currentFrame - 1 + images.length) % images.length;
//         }

//         img.src = images[currentFrame];
//         startX = e.touches[0].pageX;
//       }
//     });

//   });

// });





// document.addEventListener("DOMContentLoaded", function() {

//   const viewers = document.querySelectorAll(".custom-360-wrapper");

//   viewers.forEach(wrapper => {

//     const image = wrapper.querySelector(".spin-image");

//     const totalFrames = parseInt(wrapper.dataset.frames);
//     const basePath = wrapper.dataset.path;
//     const prefix = wrapper.dataset.prefix;
//     const extension = wrapper.dataset.ext;
//     const version = wrapper.dataset.version || "";

//     if (!prefix || !totalFrames || !extension) return;

//     let currentFrame = 1;
//     let isDragging = false;
//     let startX = 0;

//     const images = [];
//     for (let i = 1; i <= totalFrames; i++) {
//       let num = i.toString().padStart(2, '0');
//       let img = new Image();
//       img.src = basePath + prefix + num + extension + version;
//       images.push(img);
//     }

//     function updateImage(frame) {
//       let index = (frame - 1 + totalFrames) % totalFrames;
//       image.src = images[index].src;
//     }

//     function startDrag(x) {
//       isDragging = true;
//       startX = x;
//     }

//     function stopDrag() {
//       isDragging = false;
//     }

//     function dragMove(x) {
//       if (!isDragging) return;

//       let delta = startX - x;
//       let frameChange = Math.floor(delta / 3);

//       if (frameChange !== 0) {
//         currentFrame += frameChange;
//         currentFrame = ((currentFrame - 1 + totalFrames) % totalFrames) + 1;
//         updateImage(currentFrame);
//         startX = x;
//       }
//     }

//     wrapper.addEventListener("mousedown", e => startDrag(e.pageX));
//     window.addEventListener("mouseup", stopDrag);
//     window.addEventListener("mousemove", e => dragMove(e.pageX));

//     wrapper.addEventListener("touchstart", e => startDrag(e.touches[0].pageX));
//     window.addEventListener("touchend", stopDrag);
//     window.addEventListener("touchmove", e => dragMove(e.touches[0].pageX));

//   });

// });








// document.addEventListener("DOMContentLoaded", function () {

// var currentIndex = 0;
// var filteredImages = [];

// function filterImagesBySwatch() {

//     var selectedInput = document.querySelector('.ctm_swatches input:checked');
//     if (!selectedInput) return;

//     var swatchValue = selectedInput.closest('.ctm_swatches')
//         .getAttribute('data-swatch')
//         .toLowerCase()
//         .trim();

//     var items = document.querySelectorAll('.feature-media-item');

//     filteredImages = [];
//     currentIndex = 0;

//     items.forEach(function(item) {

//         var alt = item.getAttribute('data-product-image-alt');

//         if (alt && alt.toLowerCase().includes(swatchValue)) {
//             item.style.display = "block";
//             filteredImages.push(item);
//         } else {
//             item.style.display = "none";
//         }

//     });

//     if (filteredImages.length > 0) {
//         filteredImages.forEach(function(img, i) {
//             img.style.display = (i === currentIndex) ? "block" : "none";
//         });
//     }
// }

// function stopButtonClick(e) {

//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     if (filteredImages.length === 0) {
//         filterImagesBySwatch();
//     }

//     if (filteredImages.length === 0) return false;

//     currentIndex++;

//     if (currentIndex >= filteredImages.length) {
//         currentIndex = 0;
//     }

//     filteredImages.forEach(function(img, i) {
//         img.style.display = (i === currentIndex) ? "block" : "none";
//     });

//     return false;
// }


// // next button
// var nextBtn = document.querySelector('.ctm_next_btn');
// if (nextBtn) {
//     nextBtn.addEventListener('click', stopButtonClick, true);
// }


// // prev button
// var prevBtn = document.querySelector('.ctm_prev_btn');
// if (prevBtn) {

//     prevBtn.addEventListener('click', function(e) {

//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();

//         if (filteredImages.length === 0) {
//             filterImagesBySwatch();
//         }

//         if (filteredImages.length === 0) return false;

//         currentIndex--;

//         if (currentIndex < 0) {
//             currentIndex = filteredImages.length - 1;
//         }

//         filteredImages.forEach(function(img, i) {
//             img.style.display = (i === currentIndex) ? "block" : "none";
//         });

//         return false;

//     }, true);
// }


// // ⭐ Variant change detect
// document.querySelectorAll('.ctm_swatches input').forEach(function(input){
//     input.addEventListener('change', function(){
//         filterImagesBySwatch();
//     });
// });



// });


document.addEventListener("DOMContentLoaded", function () {

  function filterImagesByColor(color) {
    if (!color) return;

    document.querySelectorAll("li[data-mediaalt]").forEach(function (item) {
      var mediaAlt = item.getAttribute("data-mediaalt");

      if (mediaAlt && mediaAlt.toLowerCase() === color.toLowerCase()) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  /* 🔹 CLICK par (tumhara existing code extended) */
  document.querySelectorAll(".ctm_swatches").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      var swatchValue = this.getAttribute("data-swatch");
      filterImagesByColor(swatchValue);
    });
  });

  /* 🔹 PAGE LOAD par (checked variant se) */
  var checkedInput = document.querySelector(
    '.ctm_swatches input[type="radio"]:checked'
  );

  if (checkedInput) {
    var parentSwatch = checkedInput.closest(".ctm_swatches");
    var defaultColor = parentSwatch.getAttribute("data-swatch");
    filterImagesByColor(defaultColor);
  }

});







document.addEventListener("DOMContentLoaded", function () {

  const image = document.getElementById("spin-image");
  const wrapper = document.querySelector(".custom-360-wrapper");

  const totalFrames = 18;
  const dragSpeed = 0.15; // lower = slower rotation (smooth control)

  const basePath = "https://cdn.shopify.com/s/files/1/0700/7502/3383/files/";
  const version = "?v=1771434363";

  let currentFrame = 0;
  let isDragging = false;
  let lastX = 0;
  let velocity = 0;

  // ✅ Preload frames
  const frames = [];
  for (let i = 1; i <= totalFrames; i++) {
    let num = i.toString().padStart(2, "0");
    let img = new Image();
    img.src = basePath + "frame_" + num + ".jpg" + version;
    frames.push(img);
  }

  function render() {
    let frameIndex = Math.floor(currentFrame) % totalFrames;
    if (frameIndex < 0) frameIndex += totalFrames;
    image.src = frames[frameIndex].src;
  }

  function animate() {
    if (!isDragging && Math.abs(velocity) > 0.01) {
      currentFrame += velocity;
      velocity *= 0.95; // friction (smooth slow down)
      render();
    }
    requestAnimationFrame(animate);
  }

  animate();

  function startDrag(x) {
    isDragging = true;
    lastX = x;
    velocity = 0;
    wrapper.style.cursor = "grabbing";
  }

  function stopDrag() {
    isDragging = false;
    wrapper.style.cursor = "grab";
  }

  function dragMove(x) {
    if (!isDragging) return;

    let delta = lastX - x; // correct direction
    velocity = delta * dragSpeed;
    currentFrame += velocity;
    render();
    lastX = x;
  }

  // Desktop
  wrapper.addEventListener("mousedown", e => startDrag(e.pageX));
  window.addEventListener("mouseup", stopDrag);
  window.addEventListener("mousemove", e => dragMove(e.pageX));

  // Mobile
  wrapper.addEventListener("touchstart", e => startDrag(e.touches[0].pageX));
  window.addEventListener("touchend", stopDrag);
  window.addEventListener("touchmove", e => dragMove(e.touches[0].pageX));

});





// document.addEventListener("DOMContentLoaded", function () {

// var currentIndex = 0;
// var filteredImages = [];

// function filterImagesBySwatch() {

//     var selectedInput = document.querySelector('.ctm_swatches input:checked');
//     if (!selectedInput) return;

//     var swatchValue = selectedInput.closest('.ctm_swatches')
//         .getAttribute('data-swatch')
//         .toLowerCase()
//         .trim();

//     var items = document.querySelectorAll('.feature-media-item');

//     filteredImages = [];
//     currentIndex = 0;

//     items.forEach(function(item) {

//         var alt = item.getAttribute('data-product-image-alt');

//         if (alt) {
//             var altValue = alt.toLowerCase().trim();

//             // 👉 comma ya line break se split
//             var parts = altValue.split(/,|\n/).map(v => v.trim());
//             var lastPart = parts[parts.length - 1]; // last value (e.g. hunter)

//             // ⭐ hunter ke liye exact match
//             if (
//                 (swatchValue === "hunter" && lastPart === "hunter") || 
//                 (swatchValue !== "hunter" && altValue.includes(swatchValue))
//             ) {
//                 item.style.display = "block";
//                 filteredImages.push(item);
//             } else {
//                 item.style.display = "none";
//             }
//         } else {
//             item.style.display = "none";
//         }

//     });

//     if (filteredImages.length > 0) {
//         filteredImages.forEach(function(img, i) {
//             img.style.display = (i === currentIndex) ? "block" : "none";
//         });
//     }
// }

// function stopButtonClick(e) {

//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     if (filteredImages.length === 0) {
//         filterImagesBySwatch();
//     }

//     if (filteredImages.length === 0) return false;

//     currentIndex++;

//     if (currentIndex >= filteredImages.length) {
//         currentIndex = 0;
//     }

//     filteredImages.forEach(function(img, i) {
//         img.style.display = (i === currentIndex) ? "block" : "none";
//     });

//     return false;
// }


// // next button
// var nextBtn = document.querySelector('.ctm_next_btn');
// if (nextBtn) {
//     nextBtn.addEventListener('click', stopButtonClick, true);
// }


// // prev button
// var prevBtn = document.querySelector('.ctm_prev_btn');
// if (prevBtn) {

//     prevBtn.addEventListener('click', function(e) {

//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();

//         if (filteredImages.length === 0) {
//             filterImagesBySwatch();
//         }

//         if (filteredImages.length === 0) return false;

//         currentIndex--;

//         if (currentIndex < 0) {
//             currentIndex = filteredImages.length - 1;
//         }

//         filteredImages.forEach(function(img, i) {
//             img.style.display = (i === currentIndex) ? "block" : "none";
//         });

//         return false;

//     }, true);
// }


// // ⭐ Variant change detect
// document.querySelectorAll('.ctm_swatches input').forEach(function(input){
//     input.addEventListener('change', function(){
//         filterImagesBySwatch();
//     });
// });

// });



document.addEventListener("DOMContentLoaded", function () {

var currentIndex = 0;
var filteredImages = [];

function filterImagesBySwatch() {

    var selectedInput = document.querySelector('.ctm_swatches input:checked');
    if (!selectedInput) return;

    var swatchValue = selectedInput.closest('.ctm_swatches')
        .getAttribute('data-swatch')
        .toLowerCase()
        .trim();

    var items = document.querySelectorAll('.feature-media-item');

    filteredImages = [];
    currentIndex = 0;

    items.forEach(function(item) {

        var alt = item.getAttribute('data-product-image-alt');

        if (alt) {
            var altValue = alt.toLowerCase().trim();

            // comma ya line break se split
            var parts = altValue.split(/,|\n/).map(v => v.trim());
            var lastPart = parts[parts.length - 1]; 

            // ⭐ SAB ke liye exact match
            if (lastPart === swatchValue) {
                item.style.display = "block";
                filteredImages.push(item);
            } else {
                item.style.display = "none";
            }

        } else {
            item.style.display = "none";
        }

    });

    if (filteredImages.length > 0) {
        // filteredImages.forEach(function(img, i) {
        //     img.style.display = (i === currentIndex) ? "block" : "none";
        // });
        filteredImages.forEach(function(item, i) {

    item.style.display = (i === currentIndex) ? "block" : "none";

    const video = item.querySelector("video");

    if (video) {
        if (i === currentIndex) {
            video.currentTime = 0;

            video.play().catch(function(err){
                console.log(err);
            });

        } else {
            video.pause();
        }
    }

    

});
    }
}

function stopButtonClick(e) {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (filteredImages.length === 0) {
        filterImagesBySwatch();
    }

    if (filteredImages.length === 0) return false;

    currentIndex++;

    if (currentIndex >= filteredImages.length) {
        currentIndex = 0;
    }

    // filteredImages.forEach(function(img, i) {
    //     img.style.display = (i === currentIndex) ? "block" : "none";
    // });
filteredImages.forEach(function(item, i) {

    item.style.display = (i === currentIndex) ? "block" : "none";

    const video = item.querySelector("video");

    if (video) {
        if (i === currentIndex) {
            video.currentTime = 0;

            video.play().catch(function(err){
                console.log(err);
            });

        } else {
            video.pause();
        }
    }

});
    return false;
}


// next button
var nextBtn = document.querySelector('.ctm_next_btn');
if (nextBtn) {
    nextBtn.addEventListener('click', stopButtonClick, true);
}


// prev button
var prevBtn = document.querySelector('.ctm_prev_btn');
if (prevBtn) {

    prevBtn.addEventListener('click', function(e) {

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (filteredImages.length === 0) {
            filterImagesBySwatch();
        }

        if (filteredImages.length === 0) return false;

        currentIndex--;

        if (currentIndex < 0) {
            currentIndex = filteredImages.length - 1;
        }

        // filteredImages.forEach(function(img, i) {
        //     img.style.display = (i === currentIndex) ? "block" : "none";
        // });
        filteredImages.forEach(function(item, i) {

    item.style.display = (i === currentIndex) ? "block" : "none";

    const video = item.querySelector("video");

    if (video) {
        if (i === currentIndex) {
            video.currentTime = 0;

            video.play().catch(function(err){
                console.log(err);
            });

        } else {
            video.pause();
        }
    }

});

        return false;

    }, true);
}


// variant change
document.querySelectorAll('.ctm_swatches input').forEach(function(input){
    input.addEventListener('change', function(){
        filterImagesBySwatch();
    });
});

});




// document.addEventListener("DOMContentLoaded", function () {

//   const data = window.product360Data;
//   if (!data || !data.images || data.images.length === 0) return;

//   const wrap = document.getElementById("product360Wrap");
//   const img = document.getElementById("product-360-image");

//   let currentIndex = 0;
//   let isDragging = false;
//   let startX = 0;

//   wrap.style.display = "block";
//   img.src = data.images[0];

//   // ===== DESKTOP =====
//   wrap.addEventListener("mousedown", function (e) {
//     isDragging = true;
//     startX = e.pageX;
//   });

//   window.addEventListener("mouseup", function () {
//     isDragging = false;
//   });

//   window.addEventListener("mousemove", function (e) {
//     if (!isDragging) return;
//     handleMove(e.pageX);
//   });

//   // ===== MOBILE =====
//   wrap.addEventListener("touchstart", function (e) {
//     isDragging = true;
//     startX = e.touches[0].pageX;
//   });

//   window.addEventListener("touchend", function () {
//     isDragging = false;
//   });

//   window.addEventListener("touchmove", function (e) {
//     if (!isDragging) return;
//     handleMove(e.touches[0].pageX);
//   });

//   // ===== COMMON FUNCTION =====
//   function handleMove(currentX) {
//     let diff = currentX - startX;

//     if (Math.abs(diff) > 10) {
//       if (diff > 0) {
//         currentIndex = (currentIndex - 1 + data.images.length) % data.images.length;
//       } else {
//         currentIndex = (currentIndex + 1) % data.images.length;
//       }

//       img.src = data.images[currentIndex];
//       startX = currentX;
//     }
//   }

// });







// document.addEventListener("click", function (e) {

//   const li = e.target.closest(".splide__list li");
//   if (!li) return;

//   const productMedia = li.closest(".product-media");
//   if (!productMedia) return;

//   const slider = productMedia.querySelector(".custom_prd_slider");
//   if (!slider) return;

//   // pehle dono classes hata do (optional but better)
//   slider.classList.remove("active", "first-active");

//   // check karo first child hai ya nahi
//   if (li === li.parentNode.firstElementChild) {
//     slider.classList.add("first-active"); // first li ke liye
//   } else {
//     slider.classList.add("active"); // baaki li ke liye
//   }

// });


